import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Star, X, ThumbsUp, ThumbsDown } from 'lucide-react';
import api from '../../lib/api';
import { useAuth } from '../../hooks/useAuth';
import toast from 'react-hot-toast';

export default function RatingPromptBanner() {
  const { user, isStaff } = useAuth();
  const navigate = useNavigate();
  const [pending, setPending] = useState([]);
  const [dismissed, setDismissed] = useState(false);
  const [ratingId, setRatingId]   = useState(null);
  const [saving, setSaving]       = useState(false);

  useEffect(() => {
    if (!user || isStaff) return;
    api.get('/ratings/pending').then(d => setPending(d.pending || [])).catch(() => {});
  }, [user, isStaff]);

  if (isStaff || dismissed || pending.length === 0) return null;

  const ticket = pending[0]; // Show one at a time

  async function rate(ticketId, value) {
    setSaving(true);
    try {
      await api.post(`/ratings/${ticketId}`, { rating: value });
      toast.success('Thanks for your feedback!');
      setPending(p => p.filter(t => t.id !== ticketId));
    } catch (e) { toast.error(e.message); }
    finally { setSaving(false); }
  }

  return (
    <div style={{
      background: 'linear-gradient(135deg, #1a1a18 0%, #2a2a28 100%)',
      color: '#fff',
      padding: '14px 20px',
      display: 'flex',
      alignItems: 'center',
      gap: 16,
      flexWrap: 'wrap',
    }}>
      <Star size={16} style={{ color: '#fbbf24', flexShrink: 0 }} />
      <div style={{ flex: 1, minWidth: 200 }}>
        <span style={{ fontSize: 13 }}>
          How did we do on <button onClick={() => navigate(`/tickets/${ticket.ticket_number}`)} style={{ background: 'none', border: 'none', color: '#fbbf24', cursor: 'pointer', fontSize: 13, fontWeight: 600, padding: 0 }}>
            #{ticket.ticket_number}: {ticket.subject?.slice(0, 50)}
          </button>?
        </span>
        {pending.length > 1 && <span style={{ fontSize: 11, opacity: 0.6, marginLeft: 8 }}>+{pending.length - 1} more</span>}
      </div>
      <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
        <button
          onClick={() => rate(ticket.id, 'thumbs_up')}
          disabled={saving}
          style={{ display: 'flex', alignItems: 'center', gap: 5, padding: '6px 14px', borderRadius: 6, border: '1px solid #10b981', background: 'none', color: '#10b981', cursor: 'pointer', fontSize: 13, fontWeight: 500 }}
        >
          <ThumbsUp size={13} /> Good
        </button>
        <button
          onClick={() => rate(ticket.id, 'thumbs_down')}
          disabled={saving}
          style={{ display: 'flex', alignItems: 'center', gap: 5, padding: '6px 14px', borderRadius: 6, border: '1px solid #ef4444', background: 'none', color: '#ef4444', cursor: 'pointer', fontSize: 13, fontWeight: 500 }}
        >
          <ThumbsDown size={13} /> Not great
        </button>
        <button
          onClick={() => setDismissed(true)}
          style={{ background: 'none', border: 'none', color: 'rgba(255,255,255,0.5)', cursor: 'pointer', padding: '4px' }}
          title="Dismiss"
        >
          <X size={14} />
        </button>
      </div>
    </div>
  );
}
